/**
 * Route Constants
 *
 * Type-safe route paths for navigation.
 *
 * @module routes/routes
 */

/**
 * Application route paths
 *
 * Use these constants instead of hardcoded strings for type-safe navigation.
 *
 * @example
 * ```tsx
 * import { ROUTES } from '@/routes/routes';
 *
 * <Link to={ROUTES.DASHBOARD}>Dashboard</Link>
 * navigate(ROUTES.GEOGRAPHY.PROVINCES);
 * ```
 */
export const ROUTES = {
  /** Dashboard home */
  DASHBOARD: '/',



  /** Teams routes */
  TEAMS: {
    /** Teams overview */
    ROOT: '/teams',
    /** Province team members */
    PROVINCE: '/teams/province',
    /** Region team members */
    REGION: '/teams/region',
    /** District team members */
    DISTRICT: '/teams/district',
    /** Town team members */
    TOWN: '/teams/town',
    /** UC team members */
    UC: '/teams/uc',
  },

  /** Designations routes */
  DESIGNATIONS: {
    /** Designations overview */
    ROOT: '/designations',
  },
  MEMBER_REGISTRATION: {
    ROOT: '/member-registration',
  },
  TICKET_HOLDER: {
    ROOT: '/ticket-holder',
    CREATE: '/ticket-holder/create',
    EDIT: '/ticket-holder/edit/:id',
    DETAILS: '/ticket-holder/view/:id',
  },
  REGIONS: {
    ROOT: '/regions',
  },
  DISTRICTS: {
    ROOT: '/districts',
  },
  WINGS: {
    ROOT: '/wings',
  },
  TOWNS: {
    ROOT: '/towns',
  },
  UCS: {
    ROOT: '/ucs',
  },
  PTI_ACTIVITY: {
    ROOT: '/pti-activity',
  },
} as const;

/**
 * Route labels for navigation menus (internationalized)
 */
export const ROUTE_LABELS = {
  DASHBOARD: 'nav.dashboard',

  TEAMS: {
    ROOT: 'nav.teams',
    PROVINCE: 'teams.provinceTeam',
    REGION: 'teams.regionTeam',
    DISTRICT: 'teams.districtTeam',
    TOWN: 'teams.townTeam',
    UC: 'teams.ucTeam',
  },
  DESIGNATIONS: {
    ROOT: 'nav.designations',
  },
  WINGS: {
    ROOT: 'nav.wings',
  },
  PTI_ACTIVITY: {
    ROOT: 'nav.ptiActivity',
  },
} as const;